<template>
  <motlet :options="motletOptions">
    <template #content>
      <v-row class="h-100">
        <v-col>
          <v-row class="h-100">
            <v-col class="col-20">
              <v-card class="card-wrap">
                <v-card-title>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on" class="ellipsis">Abap Dump</span>
                    </template>
                    <span>Abap Dump</span>
                  </v-tooltip>
                </v-card-title>
                <v-card-text class="data-area">
                  <v-row class="h-100">
                    <v-col class="text-right text-h4 mr-1">
                      <liquid :value="values.cntAbapDump" :contextmenu="onContextmenuAbapDump" />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col class="col-20">
              <v-card class="card-wrap">
                <v-card-title>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on" class="ellipsis">Enqueue Lock</span>
                    </template>
                    <span>Enqueue Lock</span>
                  </v-tooltip>
                </v-card-title>
                <v-card-text class="data-area">
                  <v-row class="h-100">
                    <v-col class="text-right text-h4 mr-1">
                      <liquid :value="values.rawEnqueueLock" :contextmenu="onContextmenuEnqueueLock" />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col class="col-20">
              <v-card class="card-wrap">
                <v-card-title>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on" class="ellipsis">Exclusive Lock</span>
                    </template>
                    <span>Exclusive Lock</span>
                  </v-tooltip>
                </v-card-title>
                <v-card-text class="data-area">
                  <v-row class="h-100">
                    <v-col class="text-right text-h4 mr-1">
                      <liquid :value="values.rawExclusiveLock" :contextmenu="onContextmenuExclusiveLock" />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col class="col-20">
              <v-card class="card-wrap">
                <v-card-title>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on" class="ellipsis">Update Record</span>
                    </template>
                    <span>Update Record</span>
                  </v-tooltip>
                </v-card-title>
                <v-card-text class="data-area">
                  <v-row class="h-100">
                    <v-col class="text-right text-h4 mr-1">
                      <liquid :value="values.rawUpdateRecord" :contextmenu="onContextmenuUpdateRecord" />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col class="col-20">
              <v-card class="card-wrap">
                <v-card-title>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on" class="ellipsis">Logon Duplication</span>
                    </template>
                    <span>Logon Duplication</span>
                  </v-tooltip>
                </v-card-title>
                <v-card-text class="data-area">
                  <v-row class="h-100">
                    <v-col class="text-right text-h4 mr-1">
                      <liquid :value="values.rawLogonDup" :contextmenu="onContextmenuLogonDuplication" />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>
    <template #menu>
      <contextmenu :options="contextmenuParam"></contextmenu>
    </template>
  </motlet>
</template>

<script>
import instanceable from './mixins/instanceable';
import contextmenuable from './mixins/contextmenuable';
import Liquid from '../chart/Liquid.vue';

export default {
  mixins: [instanceable, contextmenuable],
  components: {
    Liquid,
  },
  data() {
    return {
      motletOptions: {
        id: 'overview/system/abap/SystemSummary',
        title: 'System Summary',
      },
      messages: [
        {
          name: 'cntAbapDump',
          fields: ['stime', 'cnt'],
        },
        {
          name: 'rawEnqueueLock',
          fields: ['stime', 'gname'],
        },
        {
          name: 'rawExclusiveLock',
          fields: ['stime', 'sstmId', 'h_hostname'],
        },
        {
          name: 'rawUpdateRecord',
          fields: ['stime'],
        },
        {
          name: 'rawLogonDup',
          fields: ['stime', 'mandt', 'bname'],
        },
      ],
      values: {
        cntAbapDump: null,
        rawEnqueueLock: null,
        rawExclusiveLock: null,
        rawUpdateRecord: null,
        rawLogonDup: null,
      },
      contextmenuUrl: '',
    };
  },
  watch: {
    instances: {
      handler: 'changeInstancesHandler',
    },
  },
  methods: {
    // BEGIN::Removed.by.KWShin.
    // 어차피 Buffered data의 마지막 건만 필요한 경우
    // 구독 시 buffer() handler를 안 보내면
    // 서버에서 Buffered data의 마지막 건만 every() handler로 보내도록 수정함.
    // wsBufferedDataHandler(key, responses, every) {
    //   const [response] = responses;
    //   const last = response.length ? response[response.length - 1] : { data: [], ctime: '', empty: true };
    //   every(key, last.data, last.ctime, last.empty);
    // },
    // FINISH::Removed.by.KWShin.
    wsDataHandler(key, response) {
      const logonDuplicatedList = [];
      if (key.name == this.messages[0].name) {
        Object.keys(this.values).forEach(k => (this.values[k] = 0));
        logonDuplicatedList.length = 0;
      }
      response.forEach(res => {
        // Abap Dump
        if (key.name == 'cntAbapDump') {
          this.values[key.name] = (this.values[key.name] ?? 0) + parseInt(res.cnt ?? 0);
        }
        // Logon Duplication
        else if (key.name == 'rawLogonDup') {
          const duplicatedList = logonDuplicatedList.filter(item => item.mandt == res.mandt && item.bname == res.bname);
          // 중복 건 존재 시 count 증가
          if (duplicatedList.length) this.values[key.name] = (this.values[key.name] ?? 0) + 1;
          else logonDuplicatedList.push(res);
        }
        // Enqueue Lock, Exclusive Lock, Update Record
        else {
          // console.log(key.name, res);
          this.values[key.name] = (this.values[key.name] ?? 0) + 1;
        }
      });
    },
    sendMessage() {
      const requests = this.messages.map(message => ({
        key: { name: message.name, sstmId: this.instances[0].systemId },
        fields: message.fields,
        handler: {
          // buffer: this.wsBufferedDataHandler,
          every: this.wsDataHandler,
        },
      }));
      this.$websocket.realtime.send({ requests });
    },
    changeInstancesHandler() {
      this.sendMessage();
    },
    onContextmenuAbapDump(event) {
      this.contextmenuUrl = '/views/detailview/abap/dump';
      this.onContextmenuChart(event);
    },
    onContextmenuEnqueueLock(event) {
      this.contextmenuUrl = '/views/detailview/abap/ci';
      this.onContextmenuChart(event);
    },
    onContextmenuExclusiveLock(event) {
      this.contextmenuUrl = '/views/detailview/abap/ci';
      this.onContextmenuChart(event);
    },
    onContextmenuUpdateRecord(event) {
      this.contextmenuUrl = '/views/detailview/abap/ci';
      this.onContextmenuChart(event);
    },
    onContextmenuLogonDuplication(event) {
      this.contextmenuUrl = '/views/detailview/abap/user';
      const actives = this.instances.filter(d => d.active);
      const selectedDescendant = actives.length > 1 ? {} : actives[0];
      this.onContextmenuChart(event, selectedDescendant);
    },
  },
};
</script>

<style scoped>
.ellipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
  width: 100px;
  overflow: hidden;
}
.col-20 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 20%;
  flex: 0 0 20%;
  max-width: 20%;
}
.data-area {
  height: calc(100% - 37px);
}
</style>
